import CustomerDeleteActivity from "./CustomerDeleteActivity";
import CustomerDeleteActivityPopup from "./CustomerDeleteActivityPopup";

export default CustomerDeleteActivity;

export { CustomerDeleteActivityPopup };
